import React from 'react'


export function NotFound () {
	return (
        <div>
            <h1 className="m-20 font-mono text-5xl text-center">404- Page not Found</h1>
        </div>
    )
}